import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseOneResponse } from '../../shared/model/interface/crud-response-interface.model';
import { IIssuer } from '../../shared/component/issuer/issuer.model';
import {
  IFormioESignDeleteEventPayload,
  IFormioESignEventPayload,
  IFormioESignEventResponse,
} from './formio-e-signature.model';
import { IIssuerAndReason } from '../../shared/component/before-action-preparer/before-action-preparer.model';

@Injectable({
  providedIn: 'root',
})
export class FormioESignatureService {
  private readonly URLS = {
    FORMIO_SIGN_EVENT_URL: `${this.baseUrl}/form-submission-signs/`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public createFormioESignData(
    params: IFormioESignEventPayload,
  ): Observable<IBaseOneResponse<IFormioESignEventResponse>> {
    return this.http.post<IBaseOneResponse<IFormioESignEventResponse>>(this.URLS.FORMIO_SIGN_EVENT_URL, {
      issuer: params.issuer,
      payload: params.payload,
    });
  }

  public deleteFormioESignData(
    id: string,
    issuerAndReason: IIssuerAndReason,
    payload: IFormioESignDeleteEventPayload,
  ): Observable<IBaseOneResponse<IFormioESignEventResponse>> {
    return this.http.delete<IBaseOneResponse<IFormioESignEventResponse>>(`${this.URLS.FORMIO_SIGN_EVENT_URL}${id}`, {
      body: {
        issuer: issuerAndReason?.issuer,
        selectedRoles: payload.selectedRoles,
        payload: { reason: issuerAndReason.reason },
      },
    });
  }
}
